export default __webpack_public_path__ + "static/media/guinea.4a59f816.svg";